import React, { useEffect, useState } from 'react'
import component from '@/components'
import {
  ComponentItemType,
  EditConfigType,
  GlobalConfigType,
  PrefetchDataType,
  ProviderPropsType,
} from '@/typings/types'
import { px2rem } from '@/utils/styleUtils'
// import useSleepShow from '@/hooks/useSleepShow'
import ErrorBoundary from '@/common/errorBoundary'
import CustomNav from '@/common/customNav'
import CustomNavContext from '@/context/customNavContext'
import useProvider from './useProvider'
import style from './index.module.css'
import Jockeys from '@/utils/jockey'
import { isDuApp } from '@/utils/appUtils/getDevice'

// TODO type add baseType
interface IProps {
  componentList: ComponentItemType[]
  handleChangeActive: any
  globalConfig: GlobalConfigType
  isDuappBrowser: boolean
  id: string
  type: any
  editConfig: EditConfigType
  addFlag: boolean
  [key: string]: any
}

const providerKeys = ['dynamicDomain']

// TODO detail 是否应该有onClick
function ComponentWrapper(props: {
  providerProps: ProviderPropsType
  globalConfig: GlobalConfigType
  editConfig: EditConfigType
  index: number
  ComponentItem: any
  hash: any
  name: any
  id: any
  propsConfig: any
  type: any
  handleChangeActive: any
  prefetchData: PrefetchDataType
}) {
  const {
    index,
    editConfig,
    ComponentItem,
    hash,
    name,
    globalConfig,
    id,
    type,
    propsConfig,
    prefetchData,
    providerProps,
  } = props
  // TOOD setTimeout 影响组件服务端渲染逻辑
  // const [isWakeUp] = useSleepShow(index > 3 && type === 'dynamic' ? 1000 : 0)
  const isWakeUp = true
  return (
    <div
      className={`${name}___${index}`}
      key={hash}
      onClick={() => props.handleChangeActive(index)}
    >
      {/* 优化加载时序 */}
      {isWakeUp && (
        <ErrorBoundary CName={name}>
          <ComponentItem
            key={hash}
            propsConfig={propsConfig}
            editConfig={editConfig}
            componentIndex={index}
            CName={name}
            globalConfig={globalConfig}
            pageId={id}
            providerProps={providerProps}
            prefetchData={prefetchData}
          />
        </ErrorBoundary>
      )}
    </div>
  )
}

export default function View(props: IProps) {
  const {
    componentList,
    globalConfig,
    isDuappBrowser,
    id,
    type,
    editConfig,
    handleChangeActive,
  } = props

  const [state, setState] = useState({
    statusBarHeight: px2rem(84),
    statusBarHeightPx: 84,
    componentPaddingTop: px2rem(88),
  })

  useEffect(() => {
    Jockeys.getPlatformInfoCallback((d) => {
      const nextStatusBarHeight = d.statusBarHeight + 17 + 24 + 8
      const statusBarHeight = px2rem(nextStatusBarHeight) // 根据设计稿量的尺寸
      const componentPaddingTop = px2rem(d.statusBarHeight + 44)
      setState({
        statusBarHeight,
        componentPaddingTop,
        statusBarHeightPx: nextStatusBarHeight,
      })
    })
    Jockey.send('getPlatformInfo')
  }, [])

  // const [isWakeUp] = useSleepShow(1500)
  const { providerProps } = useProvider({ providerKeys })
  return (
    <CustomNavContext.Provider
      value={{
        hideNavigation: globalConfig.hideNavigation,
        statusBarStyle: globalConfig.statusBarStyle,
        navigationBackground: globalConfig.navigationBackground,
        statusBarHeight: state.statusBarHeight,
        statusBarHeightPx: state.statusBarHeightPx,
        componentPaddingTop: state.componentPaddingTop,
      }}
    >
      <div className={style.normal} style={globalConfig.style}>
        {globalConfig.hideNavigation === 1 ? (
          <CustomNav globalConfig={globalConfig} componentList={componentList} />
        ) : null}
        {globalConfig.colorMode === 0 ? (
          <div className="status-bar-placeholder" style={{ height: state.statusBarHeight }}></div>
        ) : null}
        <div>
          {componentList.map(({ name, propsConfig, hash, prefetchData }, index) => {
            const ComponentItem = component[name]
            if (ComponentItem) {
              return (
                <ComponentWrapper
                  type={type}
                  index={index}
                  propsConfig={propsConfig}
                  editConfig={editConfig}
                  ComponentItem={ComponentItem}
                  globalConfig={globalConfig}
                  hash={hash}
                  name={name}
                  key={hash}
                  id={id}
                  providerProps={providerProps}
                  handleChangeActive={handleChangeActive}
                  prefetchData={prefetchData}
                />
              )
            }
            return null
          })}
        </div>
        {/* {globalConfig.pinxuanShow && !isDuappBrowser && isWakeUp ? (
          // 优化加载时序
          <Pinxuan globalConfig={globalConfig} />
        ) : null} */}
      </div>
    </CustomNavContext.Provider>
  )
}
